export const otcMedicineFaqData = [
  {
    id: 1,
    question: 'آیا می‌توانم این داروها را بدون نسخه سفارش دهم؟',
    answer:
      'بله، داروهای این صفحه داروهای بدون نسخه هستند، اما توصیه می‌کنیم قبل از مصرف با پزشک یا داروساز مشورت کنید.',
  },
  {
    id: 2,
    question: 'قیمت سفارش های بدون نسخه چگونه محاسبه میگردد؟',
    answer:
      'پس از ثبت سفارش و تأیید توسط داروخانه، قیمت‌ها با نظارت مسئول فنی داروخانه بر اساس نرخ فروش حضوری آنها تعیین می‌شود و تپسی دکتر هیچ دخل و تصرفی در قیمت اعلام‌شده ندارد.',
  },
  {
    id: 3,
    question: 'آیا می‌توانم برای شخص دیگری دارو سفارش دهم؟',
    answer:
      'بله، پس از انتخاب اقلام سفارش و تأیید و ادامه خرید، قبل از ارسال به داروخانه گزینه‌ی ارسال برای دیگری را انتخاب کرده و شماره‌تلفن همراه و نام و نام خانوادگی تحویل‌گیرنده را وارد کنید.',
  },
  {
    id: 4,
    question: 'آیا امکان مشاوره با داروساز قبل از سفارش وجود دارد؟',
    answer:
      'بله، هنگام ثبت سفارش می‌توانید توضیحات مدنظر را برای داروخانه بنویسید و پس از ثبت، در صورت نیاز داروخانه از طریق تماس امن با شما ارتباط برقرار می‌کند.',
  },
  {
    id: 5,
    question: 'آیا محدودیت‌هایی برای سفارش داروهای بدون نسخه وجود دارد؟',
    answer:
      'بله، برخی داروها ممکن است محدودیت سنی یا تعدادی داشته باشند؛ لطفاً صفحه محصول را بررسی کنید.',
  },
];

export const supplementFaqData = [
  {
    id: 1,
    question: 'آیا میتوانم بدون نسخه مکمل سفارش بدم؟',
    answer:
      'بله، مکمل‌ها معمولاً بدون نیاز به نسخه قابل سفارش هستند، اما توصیه می‌شود قبل از مصرف با پزشک یا داروساز مشورت کنی.',
  },
  {
    id: 2,
    question: 'قیمت مکمل‌ها چگونه محاسبه می‌شود؟',
    answer:
      'قیمت‌ها توسط داروخانه‌ها بر اساس قیمت مصرف‌کننده تعیین می‌شود و ممکن است در فروشگاه‌های مختلف کمی تفاوت داشته باشد.',
  },
  {
    id: 3,
    question: 'آیا می‌توانم مکمل‌ها را برای شخص دیگری سفارش دهم؟',
    answer:
      'بله، می‌تونی برای دیگران هم سفارش بدی، فقط مطمئن شو آدرس و اطلاعات تحویل رو به‌درستی وارد کرده باشی.',
  },
  {
    id: 4,
    question: 'آیا محصولات مکمل تاریخ انقضا دارند؟',
    answer:
      'بله، تمام محصولات تاریخ تولید و انقضا دارند و در هنگام خرید، تاریخ به شما اعلام میشود.',
  }
];

export const hygieneFaqData = [
  {
    id: 1,
    question: 'آیا می‌توانم محصولات بهداشتی را بدون نسخه سفارش دهم؟',
    answer:
      'بله، بیشتر محصولات بهداشتی بدون نیاز به نسخه قابل سفارش هستند و به‌صورت آزاد به فروش می‌رسند.',
  },
  {
    id: 2,
    question: 'قیمت محصولات بهداشتی چگونه تعیین می‌شود؟',
    answer:
      'قیمت‌ها توسط داروخانه‌ها بر اساس قیمت مصرف‌کننده تعیین می‌شود و ممکن است در فروشگاه‌های مختلف کمی تفاوت داشته باشد.',
  },
  {
    id: 3,
    question: 'آیا می‌توانم محصولات بهداشتی را برای فرد دیگری سفارش دهم؟',
    answer:
      'بله، می‌تونی برای دیگران هم سفارش بدی، فقط مطمئن شو آدرس و اطلاعات تحویل رو به‌درستی وارد کرده باشی.',
  },
  {
    id: 4,
    question: 'آیا محصولات بهداشتی تاریخ انقضا دارند؟',
    answer:
      'بله، تمام محصولات تاریخ تولید و انقضا دارند و در هنگام خرید، تاریخ به شما اعلام میشود.',
  }
];

export const motherKidFaqData = [
  {
    id: 1,
    question: 'آیا می‌توانم محصولات مادر و کودک را بدون نسخه سفارش دهم؟',
    answer:
      'بیشتر محصولات مادر و کودک بدون نسخه قابل سفارش هستند، اما برای موارد تخصصی‌تر مثل مکمل‌های بارداری یا محصولات درمانی بهتر است با پزشک یا داروساز مشورت کنی.',
  },
  {
    id: 2,
    question: 'قیمت محصولات چگونه تعیین می‌شود؟',
    answer:
      'قیمت‌ها توسط داروخانه‌ها بر اساس قیمت مصرف‌کننده تعیین می‌شود و ممکن است در فروشگاه‌های مختلف کمی تفاوت داشته باشد.',
  },
  {
    id: 3,
    question: 'آیا می‌توانم محصولات بهداشتی را برای فرد دیگری سفارش دهم؟',
    answer:
      'بله، می‌تونی برای دیگران هم سفارش بدی، فقط مطمئن شو آدرس و اطلاعات تحویل رو به‌درستی وارد کرده باشی.',
  },
  {
    id: 4,
    question: 'آیا محصولات مادر و کودک تاریخ انقضا دارند؟',
    answer:
      'بله، تمام محصولات تاریخ تولید و انقضا دارند و در هنگام خرید، تاریخ به شما اعلام میشود.',
  }
];

export const equipmentFaqData = [
  {
    id: 1,
    question: 'آیا می‌توانم این تجهیزات را بدون نسخه سفارش دهم؟',
    answer:
      'بله، تجهیزات این صفحه قابل سفارش بدون نسخه هستند، اما توصیه می‌کنیم قبل از استفاده با پزشک یا متخصص مشورت کنی.',
  },
  {
    id: 2,
    question: 'قیمت این تجهیزات چگونه محاسبه می‌شود؟',
    answer:
      'قیمت‌ها توسط داروخانه‌ها بر اساس قیمت مصرف‌کننده تعیین می‌شود و ممکن است در فروشگاه‌های مختلف کمی تفاوت داشته باشد.',
  },
  {
    id: 3,
    question: 'آیا می‌توانم این تجهیزات را برای شخص دیگری سفارش دهم؟',
    answer:
      'بله، می‌تونی برای دیگران هم سفارش بدی، فقط مطمئن شو آدرس و اطلاعات تحویل رو به‌درستی وارد کرده باشی.',
  },
  {
    id: 4,
    question: 'آیا محصولات تجهیزات پزشکی تاریخ انقضا دارند؟',
    answer:
      'بله، تمام محصولات تاریخ تولید و انقضا دارند و در هنگام خرید، تاریخ به شما اعلام میشود.',
  }
];

export const defaultFaqData = [
  {
    id: 1,
    question: 'آیا می‌توانم نسخه پزشک را با کد رهگیری از تپسی دکتر دریافت کنم؟',
    answer:
      ' بله، برای دریافت نسخه پزشک، به بخش داروهای با نسخه رفته و کد رهگیری نسخه، نوع بیمه و کد ملی خود از وارد کرده و نسخه پزشک را به‌صورت آنلاین دریافت کنید.',
  },
  {
    id: 2,
    question: 'آیا می‌توانم بدون نسخه دارو سفارش بدهم؟',
    answer:
      'بله، برای سفارش دارو بدون نسخه به بخش داروهای بدون نسخه رفته و داروی مدنظر خود را انتخاب کنید، در نظر داشته باشید برای سفارش داروهای بدون نسخه نیز باید با پزشک مشورت کنید. ',
  },
  {
    id: 3,
    question: 'قیمت سفارش‌های نسخه‌ای چگونه محاسبه می‌گردد؟',
    answer:
      'داروهایی که تحت پوشش بیمه می باشند با احتساب پوشش بیمه‌ای محاسبه می‌گردد .',
  },
  {
    id: 4,
    question: 'قیمت داروها چطور مشخص می‌شود؟',
    answer:
      'پس از ثبت سفارش و تأیید توسط داروخانه قیمت داروها بر اساس نرخ فروش حضوری داروخانه توسط مسئول فنی داروخانه مشخص می‌گردد و تپسی دکتر هیچ دخل  و تصرفی در قیمت اعلام شده ندارد .',
  },
  {
    id: 5,
    question: 'آیا می‌توانم برای شخص دیگری دارو سفارش دهم؟',
    answer:
      'بله، برای دریافت نسخه پزشک، به بخش داروهای با نسخه رفته و کد رهگیری نسخه، نوع بیمه و کد ملی خود وارد کرده و نسخه پزشک را به‌صورت آنلاین دریافت کنید.',
  },
  {
    id: 6,
    question:
      'در صورت بروز مشکل در نصب و استفاده از تپسی دکتر باید چه کاری انجام بدهم؟',
    answer:
      'در صورت بروز هرگونه مشکل می‌توانید با شماره‌ تلفن پشتیبانی تپسی دکتر ۰۲۱۴۱۶۳۰۵۰۰ تماس بگیرید.',
  },
];
